module.exports = __webpack_public_path__ + "img/chat_icon.db020ec6.svg";